import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RequestService } from '../../services/request.service';
import Company from '../../model/company/company';
import { Subject } from 'rxjs';
import { SubscriptionBasedComponent } from '../../subscription-helpers/subscription-based.component';
import { SnackService } from 'src/app/services/snack.service';
import { ClientCompanySelectService } from 'src/app/services/client-company-select.service';

@Component({
  selector: 'company-picker',
  templateUrl: './company-picker.component.html',
  styleUrls: ['./company-picker.component.scss'],
})
export class CompanyPickerComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  public company: Company;

  @Input()
  public canEdit: boolean;

  @Input()
  public client = false;

  @Input()
  public disabled = false;

  @Input()
  public fullWidth: boolean = false;

  @Input()
  public title: string = 'Bedrijf';

  @Output()
  public companyIsSelected = new EventEmitter();

  companyId: number;

  loading = false;

  public searchResult: any[];
  private searchTermChanged: Subject<string> = new Subject<string>();

  constructor(
    private requestService: RequestService,
    private snackService: SnackService,
    private clientCompanySelectService: ClientCompanySelectService
  ) {
    super();
  }

  ngOnInit() {
    if (this.client && !this.disabled && this.company === null) {
      this.loading = true;
      let company = this.clientCompanySelectService.getSelectedCompany();
      this.companyId = company == null ? null : company.id;
      this.addSubscription(
        this.clientCompanySelectService.getSelectionChangedSubscribable(),
        (company) => {
          if (company.id != null) {
            this.companyId = company.id;
            this.loading = true;
            this.loadClientCompany();
          }
        }
      );
      if (this.companyId == null) {
        this.snackService.showError('Geen bedrijf ID meegegeven');
      } else {
        this.loadClientCompany();
      }
    } else if (!this.client) {
      this.addSubscription(
        this.searchTermChanged,
        (data) => {
          if (data && data.length > 1) {
            this.addSubscription(this.searchCompany(data), (response) => {
              this.searchResult = response.body;
            });
          } else {
            this.searchResult = [];
          }
        },
        (err) => {},
        500
      );
    }
  }

  loadClientCompany() {
    this.addSubscription(
      this.requestService.getNormal('/companies/' + this.companyId),
      (res) => {
        this.company = res;
        this.loading = false;
        this.companyIsSelected.emit(this.company);
      }
    );
  }

  onSearchTermChanged(searchTerm: string) {
    this.searchTermChanged.next(searchTerm);
  }

  searchCompany(term) {
    return this.requestService.get('/companies/search/' + term);
  }

  companySelected(event): void {
    this.company = event.value;
    this.companyIsSelected.emit(this.company);
  }
}
